import React from 'react';

const LicenseReport = () => {
    return (
        <div>
            <h2>License Report</h2>
            {/* 这里可以放表格或列表组件 */}
        </div>
    );
};

export default LicenseReport;
